<template>
  <v-navigation-drawer
    v-model="favoritesDrawer"
    app
    right
    temporary>
    <div class="favorites-drawer">
      <div class="favorites-drawer__header">
        <h4 class="favorites-drawer__header-title title">
          favorites
        </h4>
        <v-btn
          icon
          class="filter-drawer-close"
          @click.stop="closeFavoritesDrawer">
          <v-icon>
            close
          </v-icon>
        </v-btn>
      </div>
      <v-divider />

      <!-- IMPORTANT NOTE:
        Must do checks that currentUser exists and that
        currentUser.favorites exists, otherwise you will get an error that they are undefined.
      -->

      <div class="favorites-drawer__items-wrapper">
        <!--HATS-->
        <h5
          v-if="currentUser && currentUser.favorites && currentUser.favorites.hats.length > 0"
          class="favorites-drawer__section-header">
          hats
        </h5>
        <ul
          v-if="currentUser && currentUser.favorites && currentUser.favorites.hats.length > 0"
          class="favorites-drawer__items">
          <v-scale-transition group>
            <cart-item
              v-for="hat in currentUser.favorites.hats"
              :key="hat"
              :item="hat"
              item-set="hats"
              favorites />
          </v-scale-transition>
        </ul>

        <!--PATCHES-->
        <h5
          v-if="currentUser && currentUser.favorites && currentUser.favorites.patches.length > 0"
          class="favorites-drawer__section-header">
          patches
        </h5>
        <ul
          v-if="currentUser && currentUser.favorites && currentUser.favorites.patches.length > 0"
          class="favorites-drawer__items">
          <v-scale-transition group>
            <cart-item
              v-for="patch in currentUser.favorites.patches"
              :key="patch"
              :item="patch"
              item-set="patches"
              favorites />
          </v-scale-transition>
        </ul>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex';

import CartItem from './cart/CartItem.vue';

export default {
  name: 'FavoritesDrawer',
  components: {
    CartItem,
  },
  computed: {
    favoritesDrawer: {
      get() {
        return this.$store.state.app.favoritesDrawer;
      },
      set(value) {
        this.$store.commit('app/setFavoritesDrawer', value);
      },
    },
    ...mapState('user', {
      currentUser: 'currentUser',
    }),
  },
  methods: {
    closeFavoritesDrawer() {
      this.$store.dispatch('app/closeAllDrawers');
    },
  },
};
</script>

<style lang="stylus" scoped>
@require('../stylus/base')

.favorites-drawer
  display: flex
  flex-flow: column nowrap
  align-items: stretch
  justify-content: space-between
  height: 100%
  padding-top: 3rem
  background-color: $white

  &__header
    display: flex
    flex-flow: row nowrap
    align-items: center
    justify-content: space-between
    padding-left: $base-padding*2

  &__items-wrapper
    display: flex
    flex-flow: column nowrap
    height: 100%

  &__section-header
    display: flex
    flex-flow: row nowrap
    align-items: center
    justify-content: space-between
    padding-top: $base-padding
    padding-left: $base-padding*2
    font-size: 1rem

  &__items
    display: flex
    flex-flow: column nowrap
    align-items: stretch
    justify-content: flex-start
    padding-right: $base-padding
    padding-left: $base-padding*2
    width: 100%
    list-style: none

</style>
